import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MappedService, ServiceMappingDialogComponent } from '../service-mapping-dialog/service-mapping-dialog.component';
import { EnvironmentService } from '../environment.service';
import { GridApi, GridOptions, GridReadyEvent, ICellRendererParams, IColumnToolPanel, RowModelType, SideBarDef } from 'ag-grid-community';
import { AgGridConfigurationService } from '@app/shared/services/ag-grid-configuration.service';
import { Subscription } from 'rxjs';
import { ConstantsService } from '@app/common/constants.service';
import { AddEnvironmentComponent } from '../add-environment/add-environment.component';
import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { SliderComponent } from '@app/shared/shared-components/slider/slider.component';
import { EditEnvironmentComponent } from '../edit-environment/edit-environment.component';
import { LoaderService } from '@app/shared/services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { StatusLogComponent } from '@app/modules/deployment-status/status-log/status-log.component';
import moment from 'moment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
@Component({
    standalone: true,
    selector: 'app-environment-list',
    templateUrl: './environment-list.component.html',
    styleUrls: ['./environment-list.component.scss'],
    imports: [AgGridModule, CommonModule, AddEnvironmentComponent, EditEnvironmentComponent, SliderComponent, ServiceMappingDialogComponent, MatDialogModule, MatTooltipModule, MatIconModule]
})
export class EnvironmentListComponent implements OnInit {

  /** Controls visibility of the Add Environment overlay */
  isAddEnvironmentOverlayVisible = false;
  /** Controls visibility of the Service Mapping dialog */
  isServiceMappingDialogVisible = false;
  /** Controls visibility of the Edit Environment overlay */
  isEditEnvironmentOverlayVisible = false;
  environmentBeingEdited: any = null;
  mappedServicesForDialog: MappedService[] = [];
  isMappedServicesLoading = false;
  environmentList: any[] = [];
  serviceMappingsList: any[] = [];
  isEnvironmentListLoading = false;
  mode = '';
  loading: boolean;
  // private environmentSubscription: Subscription = new Subscription();
  /** Subscription for environment-related observables. Unsubscribed in ngOnDestroy. */
  private environmentSubscription!: Subscription;
  styleChipDiv = 'height: calc(100vh - 250px); flex: 1 1 auto; border: 1px solid #DFDFDF;';
  public overlayNoRowsTemplate =
    '<span style="font-weight: 400; color: #757575; ">No records found</span>';
  infiniteInitialRowCount = 30
  public gridApi: GridApi; // ag grid api
  paginationPageSize = 30; // ag grid pagination page size
  selectedadditionalFilterValues = [];
  dataSource: any;
  cols: any[];
  isCyberWise: boolean;
  isValidRole = true;
  currentUserId = '';
  showFilter = true;
  jsonFilterInfo: string = null;
  agGridColDef: any; // ag grid col defination
  rowModelType: RowModelType = 'serverSide'; // ag grid row model type
  // Declare a variable to store grid options value
  gridOptions: GridOptions;
  enableSlider = false;
  params: any;
  cacheBlockSize: any = 30;
  maxBlocksInCache: any = 30;
  serverSideStoreType = 'partial';
  @ViewChild(AddEnvironmentComponent, { static: false }) addEnvironmentComponent: AddEnvironmentComponent;

  public defaultColDef = {
    flex: 1, minWidth: 120, filter: true, sortable: true, resizable: true,
    maxWidth: 400,
    floatingFilter: false,
    enableRowGroup: true,
    enableValue: true,
  };
  /** ag-Grid column definitions for the environment table */
  /* istanbul ignore next */
  columnDefs = [
    { headerName: 'Environment Name', field: 'environmentName', filter: true, cellStyle: { textAlign: 'left' }, minWidth: 200 ,tooltipField: 'environmentName'},
    { headerName: 'Workflow Name', field: 'workflowName', filter: true, cellStyle: { textAlign: 'left' }, minWidth: 250 ,
   tooltipField: 'workflowName'
    },
    {
      headerName: 'Status', field: 'status', filter: true, minWidth: 150,
      cellStyle: { textAlign: 'center' ,maxWidth: 450},tooltipField: 'status',
      cellRenderer: params => {
        const btnStyle = `
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      height: 22px;
                      min-width: 100px;
                      padding: 0 6px;
                      border-radius: 12px;
                      font-weight: 500;
                      cursor: default;
                      white-space: nowrap;
                      border: none;
                      box-shadow: 0 1px 2px rgba(60,60,60,0.07);
                  `;
        if (params.value === 'Active') {
          return `    <div style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;">
            <span style="${btnStyle} background: #c7ecd2ff; color: #01581aff; border: none;">${params.value}</span>
          </div>`;
        }

        if (params.value === 'Inactive') {
          return `    <div style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;">
            <span style="${btnStyle} background: #FFE0B2; color: #d84901ff; border: none;">${params.value}</span>
          </div>`;
        }
        return `<span style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">${params.value}</span>`;
      }
    },
    { headerName: 'Environment Type', field: 'environmentType', filter: true, minWidth: 200, tooltipField: 'environmentType' },
    { headerName: 'Services Mapped', field: 'servicesMapped', filter: false, sortable: false, minWidth: 170, cellStyle: { textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' },
      cellRenderer: params => {
        return `<a class="ag-link" style="color: #1976d2; font-weight: 400; text-decoration: underline; cursor: pointer;">View Details</a>`;
      }
    },
    { headerName: 'Last Updated By', field: 'createdBy', filter: true, minWidth: 200, tooltipField: 'createdBy' },
    {
      field: 'createdDateTime',
      minWidth: 200,
      dataType: 'date',
      headerName: 'Last Updated On',
      filter: 'agDateColumnFilter', // <-- THIS ENABLES THE DATE PICKER!
      filterParams: {
        buttons: ['clear'],
        filterOptions: ['equals'],
        defaultOption: 'equals',
        suppressAndOrCondition: true,
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          if (!cellValue) return -1;
          const cellDate = new Date(cellValue);
          if (
            cellDate.getFullYear() === filterLocalDateAtMidnight.getFullYear() &&
            cellDate.getMonth() === filterLocalDateAtMidnight.getMonth() &&
            cellDate.getDate() === filterLocalDateAtMidnight.getDate()
          ) {
            return 0;
          }
          return -1;
        }
      },
      tooltipValueGetter: (params: ICellRendererParams) => params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '',
      cellRenderer: (params: ICellRendererParams) => {
        const formattedDate = params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
        return formattedDate;
      }
    },
    {
      headerName: 'Action', field: 'action', filter: false, sorting: false, width: 120, maxWidth: 120,
      cellRenderer: params => {
        const canEdit = this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.MODIFY');
        return `
          <div style="display: flex; align-items: center; justify-content: center; text-align: center; height: 100%;">
            <span class="ag-link edit-box-outline ${canEdit ? '' : 'disabled'}"
                  style="color: #222; font-weight: 400; cursor: ${canEdit ? 'pointer' : 'not-allowed'}; display: inline-flex; align-items: center; border: 1px solid #222; border-radius: 4px; padding: 2px 4px; ${canEdit ? '' : 'pointer-events: none; opacity: 0.5;'}">
              <span class="material-icons" style="font-size: 18px; vertical-align: middle; color: #222;">edit</span>
            </span>
          </div>`;
      },
    }
  ];

  /** ag-Grid row data for the environment table */
  environmentTableRowData: any[] = [];
  isProcessingClick = false;

  /**
   * Constructor injects required services.
   * @param router Angular Router for navigation
   * @param environmentService Service for environment data
   */
  constructor(private router: Router, private environmentService: EnvironmentService,
    public readonly agGridConfigurationService: AgGridConfigurationService,
    public route: ActivatedRoute,
    public constantService: ConstantsService,
    public loaderService: LoaderService,
    private toastr: ToastrService,
    public userAuthService: UserAuthService,
    public dialog: MatDialog
  ) {
  }

  /**
   * OnInit lifecycle hook: loads environments and service mappings.
   */
  ngOnInit(): void {
    // Set the gridOptions using the agGridConfigurationService
    this.gridOptions =
    {
      // Set the localeText property by getting the agGridConfig from the agGridConfigurationService
      localeText: this.agGridConfigurationService.getAgGridConfig()
    };

    this.rowModelType = 'clientSide';
    this.isEnvironmentListLoading = true;

    // Subscribe to permission changes and update columnDefs if permissions change
    this.userAuthService.permissionUpdated.subscribe();
  }

  /** Opens the Add Environment overlay */
  showAddEnvironmentOverlay() {
    this.isAddEnvironmentOverlayVisible = true;
  }

  /** Closes the Add Environment overlay */
  hideAddEnvironmentOverlay() {
    this.isAddEnvironmentOverlayVisible = false;
  }

  // /** Handler for Add Environment button click */
  addEnvironment() {
    this.mode = 'add';
    this.enableSlider = true;
    document.getElementById('appSlider').style.width = this.constantService.sliderWidth70;
  }

  /** Closes the Service Mapping dialog */
  hideServiceMappingDialog() {
    this.isServiceMappingDialogVisible = false;
  }
  /** Closes the Edit Environment overlay */
  hideEditEnvironmentOverlay() {
    this.environmentBeingEdited = null;
    this.closeNav();
  }

  closeNav() {
    this.isEditEnvironmentOverlayVisible = false
    this.mode = '';
    this.enableSlider = false;
    document.getElementById('appSlider').style.width = this.constantService.sliderResetWidth;
  }

  /**
   * Handles cell click events in the environment table.
   * Opens the service mapping dialog or edit overlay as needed.
   * @param event ag-Grid cell click event
   */

  handleTableCellClick(event: any) {
     if (this.isProcessingClick) return;
      
    // If the user clicks the 'Services Mapped' cell, show the mapping dialog
    if (event.colDef && event.colDef.field === 'servicesMapped') {
      this.isProcessingClick = true;

      const environmentId = event.data?.id;
      this.isMappedServicesLoading = true;
      this.environmentService.getMappedServices(environmentId).subscribe({
      next: (data: any) => {
        // Only use selected services and map hasApi/hasWeb to components
        const services = Array.isArray(data?.services) ? data.services : [];
        this.mappedServicesForDialog = services
        .filter((service: any) => service.selected || service.isSelected)
        .map((service: any) => {
          const components: string[] = [];
          if (service.hasAPI) components.push('API');
          if (service.hasWeb) components.push('Web');
          return {
          serviceName: service.serviceName || service.name,
          components
          };
        });
        this.isMappedServicesLoading = false;
        this.isServiceMappingDialogVisible = true;
        const dialogConfig = new MatDialogConfig();//NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '550px';
        dialogConfig.width = '800px';
        dialogConfig.data = { title: 'Services Mapped', mappedServicesList: this.mappedServicesForDialog };

        const dialogRef = this.dialog.open(ServiceMappingDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(() => {
        this.isProcessingClick = false;
        });
      },
      error: () => {
        this.mappedServicesForDialog = [];
        this.isMappedServicesLoading = false;
        this.isServiceMappingDialogVisible = true;
        this.isProcessingClick = false;
      }
      });
    }
    // If the user clicks the 'Edit' cell, show the edit overlay
    if (event.colDef && event.colDef.field === 'action') {
      const canEdit = this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.MODIFY');
      if (!canEdit) {
        return; // Do nothing if permission is false
      }
      const environmentId = event.data?.id;
      const environment = this.environmentTableRowData.find(env => env.id === environmentId);
      this.setLoader();
      this.environmentService.getMappedServices(environmentId).subscribe({
        next: (data: any) => {
          const servicesArr = Array.isArray(data?.services) ? data.services : [];
          environment.services = servicesArr;
          this.environmentBeingEdited = { ...environment, services: servicesArr };
          this.mode = 'edit';
          this.enableSlider = true;
          document.getElementById('appSlider').style.width = this.constantService.sliderWidth70;
          this.setUnLoader();
        },
        error: () => {
          this.setUnLoader();
        }
      });
    }
  }

  /**
   * Handler for when a new environment is added.
   * Updates the environment list and closes the overlay.
   */
  handleEnvironmentAdded() {
    this.hideAddEnvironmentOverlay();
    this.refreshData();
  }
  /**
    * Handler for when an environment is edited and submitted.
    * Updates the environment list and closes the overlay.
    * @param updatedFormValue The updated environment form value
    */
  handleEditEnvironmentSubmit() {
    this.hideEditEnvironmentOverlay();
    this.refreshData();
  }

  onGridReady = (params: GridReadyEvent) => {
  if (params != undefined) {
    this.setLoader();
    this.gridApi = params.api;
    this.gridApi.setHeaderHeight(38);
    
    // Load data directly (like services-list component)
    this.loadEnvironmentData();
    
    this.setUnLoader();
  }
}
loadEnvironmentData() {
  this.setLoader();
  
  this.environmentService.getEnvironments().subscribe({
    next: (response: any[]) => {
      this.environmentTableRowData = response || [];
      
      if (this.gridApi) {
        // Set data directly to ag-Grid (like services-list component)
        this.gridApi.setGridOption('rowData', this.environmentTableRowData);
        
        if (this.environmentTableRowData.length === 0) {
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
      }
      
      this.setUnLoader();
    },
    error: (error) => {
      console.error('Error fetching environment data:', error);
      this.setUnLoader();
      this.environmentTableRowData = [];
      if (this.gridApi) {
        this.gridApi.setGridOption('rowData', []);
        this.gridApi.showNoRowsOverlay();
      }
    }
  });
}
  setPageSize() {
    this.gridApi.paginationSetPageSize(this.paginationPageSize);
  }

  /* istanbul ignore next */
  applyAdditionalFilter() {
    // default filter to be applied
    const defaultFilter = {
      status: {
        // default filter approved and unapproved
        values: this.selectedadditionalFilterValues,
        filterType: 'set'
      }
    }
    // set filter model
    //this.gridApi.setFilterModel(defaultFilter);
  }

  /* istanbul ignore next */
  createServerSideDatasource() {//NOSONAR
    return {
      getRows: (params) => { //NOSONAR
        this.params = params;
        // call the user service api to get the data
        this.environmentService.getEnvironments().subscribe({
          next: (data) => {
            this.environmentTableRowData = data;
            //this.totalRecords = data;
            // set the response data into ag grid
            params.success({
              rowData: data,
              // rowCount: +data.totalCount,
            });
            if (data.length === 0) {
              this.gridApi.showNoRowsOverlay();
            }
            else {
              this.gridApi.hideOverlay();
            }
            // select the rows based on the selected user ids
            this.gridApi.deselectAll();

          },
          error: (_error) => {
            // on error set the ag grid row data to empty
            params.success({
              rowData: [],
              rowCount: 0
            });
            this.gridApi.showNoRowsOverlay();
          }
        });
      },
    };
  }

  refreshData() {
  this.loadEnvironmentData(); 
}
  setLoader() {
    this.loading = true;
    this.loaderService.showSpinner.next(true);
  }

  setUnLoader() {
    this.loading = false;
    this.loaderService.showSpinner.next(false);
  }
}
